import React, { ReactElement, Fragment, useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { Row, Col, message, Select } from 'antd';
import {
  GUTTOR_SPACE, FETCH_DOCUMENTS, SAVE_DOCUMENT, STATUS_SUBMIT,
  APPROVAL_TYPE, OPERATION, DATA_NOT_FOUND,
  SAVE_SUCCESS, SAVE_ERROR, DOCUMENT_TYPE_SEARCH,
} from '../../../shared/constants/commonConstants';
import DocumentCard from './DocumentCard';
import SendRequest from '../../../shared/services/sendRequest.service';
import UploadModal from './UploadModal';
import ColumnLoader from './ColumnLoader';
import _ from 'lodash';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { useDispatch } from 'react-redux';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { FETCH_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { error } from '../../../utils/utility';
import { PROFILE_CONSTANTS } from './../../../shared/constants/commonConstants';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

const Documents = (): ReactElement => {

  const [isUploadModal, setIsUploadModal] = useState(false);
  const [isApiData, setIsApiData] = useState(false);
  const [isDocumentEmpty, setIsDocumentEmpty] = useState(false);
  const [documentsData, setDocumentsData] = useState(null as any);
  // const [documentsStore, setDocumentStore] = useState(null as any);
  const [selectedFolder, setSelectedFolder] = useState({} as any);
  const [uploadedDocDetails, setUploadedDocDetails] = useState([] as any);
  const sendRequest = SendRequest.instance;
  const [deleteFileId, setDeleteFileId] = useState([] as any);
  const [filterKey, setFilterKey] = useState(-1 as any);
  const [isApiCall, setIsApiCall] = useState(true);
  const { Option } = Select;
  const [children, setchildren] = useState([] as any);
  const [searchList, setSearchList] = useState([] as any);
  const [newDoc, setNewDoc] = useState([] as any);
  const [emptyCategories, setEmptyCategories] = useState(null as any);
  let documentObj;

  const dispatch = useDispatch();

  useEffect((): void => {
    dispatch(
      dashBoardRequest(
        {
          title: PROFILE_CONSTANTS.hospitalDocuments,
          url: `${process.env.REACT_APP_BASE_URL}${FETCH_DASHBOARD}`,
          type: PROFILE_CONSTANTS.document,
        },
      ),
    );
  }, []);

  useEffect((): void => {
    getFilterData();
  }, []);

  // useEffect((): void =>{
  //   fndData();
  //   setDocumentsData([] as any);
  // },[newDoc])

  useEffect((): void => {
    if (searchList && searchList.length) {
      getData();
    }
  }, [searchList]);

  useEffect((): void => {
    checkEmptyDocuments();
  }, [isApiData, isDocumentEmpty, filterKey]);

  useEffect((): void => {
    if (!documentsData) {
      setIsDocumentEmpty(true);
    }
  }, [documentsData]);

  const checkEmptyDocuments = (): void => {
    let allCategories: any;
    if (documentsData && !_.isEmpty(documentsData)) {
      allCategories = searchList.filter((item: any): boolean => {
        return Object.keys(documentsData).findIndex((v: any): boolean => +v === +item.id) === -1;
      });
    }
    if (filterKey === -1) {
      const modifiedSearchList = allCategories && allCategories.map((vv: any): any => {
        return {
          docId: '',
          docName: '',
          isActive: vv.isActive,
          profileId: ApplicationDetail.instance.getProfileId(),
          typeId: vv.id,
          typeName: vv.typeName,
          displayTypeName: vv.displayTypeName,
        };
      });
      setDocumentsData({ ...documentsData, ..._.groupBy(modifiedSearchList, 'typeId') });
      setEmptyCategories({ ..._.groupBy(modifiedSearchList, 'typeId') });
    } else {
      const filteredEmptyCategories: any[] = [];
      Object.keys(emptyCategories).forEach((v: any): any => {
        if (filterKey.findIndex((c: any): boolean => c === +v) >= 0) {
          filteredEmptyCategories.push(emptyCategories[v]);
        }
      });

      if (filteredEmptyCategories && filteredEmptyCategories.length > 0) {
        setDocumentsData({ ...documentsData, ...filteredEmptyCategories });
      }
    }
  };

  const setDefaultDocs = (): void => {
    const modifiedSearchList = searchList?.map((vv: any): any => {
      return {
        docId: '',
        docName: '',
        isActive: vv.isActive,
        profileId: ApplicationDetail.instance.getProfileId(),
        typeId: vv.id,
        typeName: vv.typeName,
        displayTypeName: vv.displayTypeName,
      };
    });
    setDocumentsData({ ..._.groupBy(modifiedSearchList, 'typeId') });
  };

  const firstLevelRestructuring = (data?: any): void => {
    setDocumentsData(_.groupBy(data, 'typeId'));
    setIsApiData(true);
  };

  const getFilterData = async (): Promise<any> => {
    const searchResponse = await sendRequest.get(process.env.REACT_APP_BASE_URL + DOCUMENT_TYPE_SEARCH) as any;
    if (searchResponse && searchResponse.isSuccess) {
      setSearchList(searchResponse.documentTypes);
      menu(searchResponse.documentTypes);
    }
  };

  const getData = async (key?: any): Promise<any> => {
    let request = {};
    setIsApiData(false);
    if (key) {
      setFilterKey(key);
      request = {
        applicationId: 123,
        userDetail: {
        },
        pageNumber: 0,
        pageSize: 500,
        documentByProfileId: true,
        documentByTypeId: true,
        typeIds: key,
        approvalType: APPROVAL_TYPE,
        operation: OPERATION,
        profileIds: [ApplicationDetail.instance.getProfileId()],
      };

    } else {
      setFilterKey(-1);
      request = {
        applicationId: 123,
        userDetail: {
        },
        pageNumber: 0,
        pageSize: 500,
        documentByProfileId: true,
        profileIds: [ApplicationDetail.instance.getProfileId()],
        approvalType: APPROVAL_TYPE,
        operation: OPERATION,
      };
    }
    const response = await sendRequest.post(process.env.REACT_APP_BASE_URL + FETCH_DOCUMENTS, request) as any;
    if (response && response.isSuccess && response.documents && response.documents.length > 0) {
      const internalDocs = response.documents.filter((v: any): boolean => v.isInternalType);
      const externalDocs = response.documents.filter((v: any): boolean => !v.isInternalType);
      if (externalDocs && externalDocs.length) {
        // setDocumentsData(null);
        firstLevelRestructuring(externalDocs);
        setIsApiCall(false);
      } else if (internalDocs && internalDocs.length) {
        // setDocumentsData(null);
        setDefaultDocs();
        // firstLevelRestructuring(internalDocs);
        setIsApiCall(false);
      }
    } else if (filterKey === -1) {
      setIsApiCall(false);
      // setDocumentsData(null);
      setDefaultDocs();
    } else {
      // setDocumentsData(null);
      setIsDocumentEmpty(true);
      setIsApiCall(false);
      setIsApiData(true);
    }
  };

  const closeModal = (): void => {
    setUploadedDocDetails([]);
    setDeleteFileId([]);
    setIsUploadModal(false);
  };

  const openUploadModal = (isupload: any, item: any): void => {
    setSelectedFolder(item);
    setIsUploadModal(isupload);
  };

  const getDocumentObject = (id?: any): any[] => {
    let docDetails = [] as any;
    if (id && id.length > 0) {
      const tempData: any = Object.values(documentsData);
      tempData.flat().forEach((file: any): any => {
        id.forEach((idValue: any): any => {
          if (file.id === idValue) {
            documentObj = {
              id: file.id,
              profileId: ApplicationDetail.instance.getProfileId(),
              typeName: file.typeName,
              docName: file.docName,
              docId: file.docId,
              startDate: file.startDate,
              endDate: file.endDate,
              description: file.description,
              approvalRemarks: file.approvalRemarks,
              isActive: false,
              statusName: STATUS_SUBMIT,
              displayTypeName: file.displayTypeName,
            };
            docDetails.push(documentObj);
          }
        });
      });
      if (uploadedDocDetails && uploadedDocDetails.length) {
        docDetails = [...docDetails, ...getNewlyUploadedFiles()];
      }
    } else {
      docDetails = getNewlyUploadedFiles();
    }
    return docDetails;
  };

  const getNewlyUploadedFiles = (): any[] => {
    const docDetails: any[] = [];
    uploadedDocDetails.forEach((item: any): any => {
      if (item.startDate && item.endDate) {
        documentObj = {
          id: item.id,
          profileId: ApplicationDetail.instance.getProfileId(),
          typeName: selectedFolder[0].typeName,
          docName: item.fileName,
          docId: item.fileGuid,
          startDate: item.startDate,
          endDate: item.endDate,
          description: selectedFolder[0].description,
          approvalRemarks: selectedFolder[0].approvalRemarks,
          isActive: true,
          statusName: STATUS_SUBMIT,
          displayTypeName: selectedFolder[0].displayTypeName,
        };
        docDetails.push(documentObj);
      } else {
        documentObj = null;
        error(<div style={{ display: 'inline-block' }}>
          Some of the uploaded files missing <b>Start date or End date</b>,
           please don't forget to click the <b>Plus icon</b>.
           </div>);
        docDetails.push(documentObj);
      }
    });
    return docDetails;
  };

  const saveUploadedDetails = async (): Promise<any> => {
    const docs = getDocumentObject(deleteFileId.length ? deleteFileId : undefined);
    if (docs && docs.length > 0 && docs.filter((v: any): any => !v).length > 0) {
      return;
    }
    const request = {
      applicationId: 9214,
      documents: docs,
    };
    setIsApiCall(true);
    const response = await sendRequest.post(process.env.REACT_APP_BASE_URL + SAVE_DOCUMENT, request) as any;
    setIsApiCall(false);
    setIsDocumentEmpty(false);
    if (response) {
      getData(filterKey !== -1 ? filterKey : undefined);
      message.success(SAVE_SUCCESS);
    } else {
      message.error(SAVE_ERROR);
    }
    closeModal();
  };

  const getUploadedFileDetails = (data: any): void => {
    if (data.fileUploadDetails) {
      setUploadedDocDetails(data.fileUploadDetails);
    } else if (uploadedDocDetails && uploadedDocDetails.length) {
      uploadedDocDetails.forEach((v: any): any => {
        if (data && v.fileName === data.name) {
          v.startDate = new Date(data?.item?.startDate) || new Date();
          v.endDate = new Date(data?.item?.endDate) || new Date();
        }
      });
      setUploadedDocDetails([...uploadedDocDetails]);
    }
  };

  const handleChange = (value: any): void => {
    const keys = [] as any;
    const newDocs = [] as any;
    searchList.map((item: any): any => {
      value.map((selected: any): any => {
        if (item.typeName === selected) {
          keys.push(item.id);
          newDocs.push(item.typeName);
        }
        return selected;
      });
      return item;
    });

    if (keys && keys.length > 0) {
      getData(keys);
    } else {
      getData();
    }
    setNewDoc(newDocs);
    //  setDocumentStore(documentsData);
  };

  const menu = (data: any): any => {
    const children11 = [] as any;
    data.map((item: any, index: any): any => {
      children11.push(<Option key={item.id + item.typeName} value={item.typeName}>{item.displayTypeName}</Option>);
      return item;
    });
    setchildren(children11);
  };

  const removeUploadedFiles = (idOrUid: any): any => {
    if (idOrUid && idOrUid.id) {
      setDeleteFileId([...deleteFileId, idOrUid.id]);
    } else if (idOrUid && idOrUid.uid) {
      setDeleteFileId([...deleteFileId]);
      const uploadedDocs = uploadedDocDetails && uploadedDocDetails.length ? [...uploadedDocDetails] : [];
      if (uploadedDocs.length) {
        setUploadedDocDetails(uploadedDocs.filter((v: any): any => v.fileName !== idOrUid.uid));
      }
    }
  };

  return (
    <Fragment>
      <PageHeader
        pageTitle="Documents" rightComponent={(): ReactElement => (
          <Row gutter={GUTTOR_SPACE} className="inv-page-header-align" justify="end">
            <Col md={8}>
              <Select
                mode="multiple"
                allowClear={true}
                className="w-100 scrollable-select mouse-pointer"
                placeholder="Search"
                onChange={handleChange}
                value={newDoc}
              >
                {children}
              </Select>
            </Col>
          </Row>
        )} />
      <div className="ant-tabs-content-holder tab-custom-container profile-documents">
        {documentsData && Object.keys(documentsData).length > 0 ?
          <Row gutter={GUTTOR_SPACE}>
            {
              Object.keys(documentsData).filter((val: any): any => {
                if (newDoc === '' || !newDoc?.length) {
                  return val;
                } else if (newDoc.toString().toLowerCase().includes(documentsData[val][0].typeName.toString().toLowerCase())) {
                  return val;
                }
              }).map((data: any, index: any): any =>
                <Col className="img-fluid" key={documentsData[data][0].typeId + documentsData[data][0].typeName + index} md={6}>
                  <DocumentCard details={documentsData[data]}
                    documentCount={documentsData[data].length} openUploadModal={openUploadModal} />
                </Col>,
              )
            }
          </Row>
          : isApiCall ? <ColumnLoader /> : DATA_NOT_FOUND}
      </div>
      <UploadModal
        isUploadModal={isUploadModal}
        closeModal={closeModal}
        saveUploadedDetails={saveUploadedDetails}
        uploadedDocDetails={uploadedDocDetails}
        deleteFileId={deleteFileId}
        selectedFolder={selectedFolder}
        getUploadedFileDetails={getUploadedFileDetails}
        removeUploadedFiles={removeUploadedFiles}
      />
    </Fragment>
  );
};

export default Documents;
